<template>
  <v-container class="email-signatures-container">
    <v-row>
      <v-col class="px-0 d-flex justify-center">
        <EcsEmailSignatures />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EcsEmailSignatures from '@/components/ecs-email-signatures/EcsEmailSignatures';
export default {
  name: 'EmailSignatures',
  components: { EcsEmailSignatures }
};
</script>

<style scoped>
.email-signatures-container {
  max-width: none;
  height: 100%;
}
</style>
